import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'lib-partial-hidden-credit-card',
  imports: [MatIconModule],
  templateUrl: './partial-hidden-credit-card.component.html',
  styleUrl: './partial-hidden-credit-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PartialHiddenCreditCardComponent {
  cardType = input.required<string>();
  lastFourDigits = input.required<string>();

  creditCardIcon = computed(() => {
    if (this.cardType() === 'visa') {
      return `ico_visa_card`;
    } else return `ico_visa_card`;
  });
}
